import { render, staticRenderFns } from "./AccountViewerLabel.vue?vue&type=template&id=1896c5d0"
import script from "./AccountViewerLabel.vue?vue&type=script&lang=js"
export * from "./AccountViewerLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports